import React from 'react';
import { Container } from 'reactstrap';
import { Breadcrumbs } from '../../../AbstractElements';
import ProductFeatures from './ProductFeatures';
import ProductGrid from './ProductGrid';

const ProductContainer = () => {
  return (
    <>
      <Container fluid={true} className='product-wrapper'>
        <Breadcrumbs justify='end' pageTitle='Product' parent='Ecommerce' title='Product' />
        <div className='product-grid'>
          <ProductFeatures />
          <ProductGrid />
        </div>
      </Container>
    </>
  );
};

export default ProductContainer;
